/**
 * Named browsing context every Sales Inventory "open borrower" link targets, so repeated
 * clicks reuse the one tab (if still open) instead of piling up a new tab per borrower.
 */
export const BORROWER_TAB_TARGET = 'si-borrower';

/** `postMessage` type the shared tab's `AppComponent` routes on. */
export const OPEN_BORROWER_MESSAGE = 'si-open-borrower';

/**
 * Click handler for links into the shared borrower tab.
 *
 * A plain left click reuses the tab without reloading it: an empty-URL `window.open` returns
 * the existing tab untouched, which is then told to route in-app via `postMessage`. A tab that
 * is new (`about:blank`) or not readable gets a normal load. Modified clicks and a blocked
 * popup fall through to the link's default. Always stops propagation so a grid row click
 * never also fires.
 */
export function openBorrowerTab(event: MouseEvent, borrowerId: number): void {
  event.stopPropagation();
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }
  const tab = window.open('', BORROWER_TAB_TARGET);
  if (!tab) {
    return;
  }
  event.preventDefault();
  const url = `/borrower/${borrowerId}`;
  let blank = true;
  try {
    blank = tab.location.href === 'about:blank';
  } catch {
    // Cross-origin page in the tab: load ours over it.
  }
  if (blank) {
    tab.location.href = url;
  } else {
    tab.postMessage({ type: OPEN_BORROWER_MESSAGE, borrowerId }, window.location.origin);
  }
  tab.focus();
}
